module.exports = __webpack_public_path__ + "img/section4.c76b263e.jpg";